import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import RenterOwnerDetails from './Details/RenterOwnerDetails';
import AdminEarning from './BillingInformation/AdminEarning';
import ReservationDetails from './Details/ReservationDetails';
import BillingInformation from './BillingInformation/BillingInformation';
import Link from '../../Link/Link';
import AdminInspectionSection from '../InspectionAdmin';

//Images
import { GoBackArrow } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

//Styles
import cs from "../../../components/commonStyle.css";
import as from '../admin-common.css';
import s from "./ViewReservation.css";
import messages from '../../../locale/jsonMessages';


const ViewReservation = ({ data, viewType }) => {
    let goBackURL;
    goBackURL = viewType === 'reservation' ? '/siteadmin/reservations' : (viewType === 'security-deposit' ? '/siteadmin/manage-security-deposit' : '/siteadmin/payout');

    return (
        <div>
            <div className={cx(cs.displayFlex, cs.justifyContentSpaceBetween, cs.alignCenter, cs.gap8, cs.flexWrap, cs.spaceBottom4)}>
                <h1 className={cx('siteAdminHeading', cs.noMargin)}>
                    {(viewType === 'reservation' || viewType === 'security-deposit')
                        ? <FormattedMessage  {...messages.viewReservationHeading} />
                        : <FormattedMessage  {...messages.payoutLabel} />
                    }
                </h1>

                <Link to={goBackURL} className='goBackLink' >
                    <GoBackArrow />
                    <FormattedMessage  {...messages.goBack} />
                </Link>
            </div>
            <RenterOwnerDetails data={data} />
            <div className={cx(cs.displayGrid, cs.gridCols2, cs.gap24, cs.gridColsMobile1, cs.gapTab0, cs.gridColsTab1)}>
                <div>
                    <AdminEarning data={data} />
                    <BillingInformation data={data} />
                </div>
                <div>
                    <ReservationDetails data={data} />
                </div>
            </div>
            {(viewType === 'reservation' || viewType === 'security-deposit') && data?.id && <AdminInspectionSection reservationId={Number(data.id)} />}
        </div>
    )
}

ViewReservation.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.number.isRequired,
        listId: PropTypes.number.isRequired,
        hostId: PropTypes.string.isRequired,
        guestId: PropTypes.string.isRequired,
        checkIn: PropTypes.string.isRequired,
        checkOut: PropTypes.string.isRequired,
        guestServiceFee: PropTypes.number.isRequired,
        hostServiceFee: PropTypes.number.isRequired,
        taxPrice: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
        reservationState: PropTypes.string.isRequired,
        listData: PropTypes.shape({
            title: PropTypes.string.isRequired
        }),
        hostData: PropTypes.shape({
            profileId: PropTypes.number.isRequired,
            firstName: PropTypes.string.isRequired
        }),
        hostPayout: PropTypes.shape({
            id: PropTypes.number.isRequired,
            payEmail: PropTypes.string.isRequired
        }),
        hostTransaction: PropTypes.shape({
            id: PropTypes.number.isRequired,
        }),
        guestData: PropTypes.shape({
            profileId: PropTypes.number.isRequired,
            firstName: PropTypes.string.isRequired
        }),
        refundStatus: PropTypes.shape({
            id: PropTypes.number.isRequired,
            receiverEmail: PropTypes.string.isRequired,
            total: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired
        }),
        cancellationDetails: PropTypes.shape({
            refundToGuest: PropTypes.number.isRequired,
            payoutToHost: PropTypes.number.isRequired,
            total: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
            guestServiceFee: PropTypes.number.isRequired,
            hostServiceFee: PropTypes.number.isRequired,
            cancellationPolicy: PropTypes.string,
            cancelledBy: PropTypes.string,
            isTaxRefunded: PropTypes.bool.isRequired,
        }),
    }),
    viewType: PropTypes.string
}

export default injectIntl(withStyles(cs, as, s)(ViewReservation));
